var map = {
	"./ion-action-sheet.entry.js": [
		1915,
		7
	],
	"./ion-alert.entry.js": [
		1916,
		8
	],
	"./ion-app_8.entry.js": [
		1917,
		9
	],
	"./ion-avatar_3.entry.js": [
		1918,
		20
	],
	"./ion-back-button.entry.js": [
		1919,
		21
	],
	"./ion-backdrop.entry.js": [
		1920,
		47
	],
	"./ion-button_2.entry.js": [
		1921,
		22
	],
	"./ion-card_5.entry.js": [
		1922,
		23
	],
	"./ion-checkbox.entry.js": [
		1923,
		24
	],
	"./ion-chip.entry.js": [
		1924,
		25
	],
	"./ion-col_3.entry.js": [
		1925,
		48
	],
	"./ion-datetime_3.entry.js": [
		1926,
		12
	],
	"./ion-fab_3.entry.js": [
		1927,
		26
	],
	"./ion-img.entry.js": [
		1928,
		49
	],
	"./ion-infinite-scroll_2.entry.js": [
		1929,
		50
	],
	"./ion-input.entry.js": [
		1930,
		27
	],
	"./ion-item-option_3.entry.js": [
		1931,
		28
	],
	"./ion-item_8.entry.js": [
		1932,
		29
	],
	"./ion-loading.entry.js": [
		1933,
		30
	],
	"./ion-menu_3.entry.js": [
		1934,
		31
	],
	"./ion-modal.entry.js": [
		1935,
		10
	],
	"./ion-nav_2.entry.js": [
		1936,
		17
	],
	"./ion-popover.entry.js": [
		1937,
		11
	],
	"./ion-progress-bar.entry.js": [
		1938,
		32
	],
	"./ion-radio_2.entry.js": [
		1939,
		33
	],
	"./ion-range.entry.js": [
		1940,
		34
	],
	"./ion-refresher_2.entry.js": [
		1941,
		13
	],
	"./ion-reorder_2.entry.js": [
		1942,
		19
	],
	"./ion-ripple-effect.entry.js": [
		1943,
		51
	],
	"./ion-route_4.entry.js": [
		1944,
		35
	],
	"./ion-searchbar.entry.js": [
		1945,
		36
	],
	"./ion-segment_2.entry.js": [
		1946,
		37
	],
	"./ion-select_3.entry.js": [
		1947,
		38
	],
	"./ion-slide_2.entry.js": [
		1948,
		52
	],
	"./ion-spinner.entry.js": [
		1949,
		15
	],
	"./ion-split-pane.entry.js": [
		1950,
		53
	],
	"./ion-tab-bar_2.entry.js": [
		1951,
		39
	],
	"./ion-tab_2.entry.js": [
		1952,
		18
	],
	"./ion-text.entry.js": [
		1953,
		40
	],
	"./ion-textarea.entry.js": [
		1954,
		41
	],
	"./ion-toast.entry.js": [
		1955,
		42
	],
	"./ion-toggle.entry.js": [
		1956,
		14
	],
	"./ion-virtual-scroll.entry.js": [
		1957,
		54
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1323;
module.exports = webpackAsyncContext;